export const initHeader = () => {
  

  /**
   * Add hover-effect to Header-li when hover megamenu
   */
  const header = document.querySelector(".site-header") as HTMLElement;
  const menuItems = header.querySelectorAll(".header-nav__li");
  const menuItemsMegamenu = document.querySelectorAll(".megamenu");
  const liMegamenu = document.querySelectorAll(".li-megamenu");

  menuItems.forEach(item => {
    item.addEventListener("mouseenter", () => {
      header.classList.add("hovered");
      item.classList.add("item--hover");
    });

    item.addEventListener("mouseleave", () => {
      header.classList.remove("hovered");
      item.classList.remove("item--hover");
    });
  });

  menuItemsMegamenu.forEach(item => {
    item.parentElement.addEventListener("mouseenter", () => {
      header.classList.add("hovered--megamenu");
      item.classList.add("item--hover");
    });
    item.parentElement.addEventListener("mouseleave", () => {
      header.classList.remove("hovered--megamenu");
      item.classList.remove("item--hover");
    });
  });

  liMegamenu.forEach(li => {
    li.addEventListener("mouseenter", () => {
      menuItems.forEach(item => {
        if (!item.classList.contains("li-megamenu")) {
          item.classList.add("not-active");
        }
      });
    });
    li.addEventListener("mouseleave", () => {
      menuItems.forEach(item => {
        item.classList.remove("not-active");
      });
    });
  })

  /**
   * Mobile Navigation
   */
  const navToggle = document.querySelector("#nav-toggle");

  navToggle.addEventListener("click", (e) => {
    document.body.classList.toggle("scroll--disabled");
    header.classList.toggle("mobile-nav--open");
    navToggle.classList.toggle("nav-toggle--active");
  });

  /**
   * Check if an HTML element with id "StartPage" exists
   */
  const startPageElement = document.getElementById("startpage") as HTMLElement;
  if (startPageElement) {
    header.classList.add("start-page");

    /**
     * Check if Hero has a dark-background
     */
    // Check if any of these classes exists.
    const classNames = ['background-color--blacks', 'background-color--red', 'background-color--grey'];
    let classExists = false;

    for (const className of classNames) {
      const elements = document.querySelectorAll(`.hero-block.block.${className}`);
      if (elements.length > 0) {
        // Elements with the current class name exist
        classExists = true;
        break; // Exit the loop as soon as one class is found
      }
    }
    // Add class to header to enable specific styling for startpage header.
    if (classExists) {
      header.classList.add("header-color--white");
    }

    const blackHero = document.querySelectorAll(".hero-block.block.background-color--black");
    if (blackHero.length > 0) {
      header.classList.add("hero--black");
    }
  }

  /**
 * Window Scroll Header
 */
  window.onscroll = () => {
    const header = document.querySelector(".site-header") as HTMLElement;
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      header.classList.add("scrolled");
      document.body.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
      document.body.classList.remove("scrolled");
    }
  };
}